import Helmet from "react-helmet";
function Seo(props) {
  const { title } = props;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#BAAF28" />
        <link rel="apple-touch-icon" href="/favicon.ico" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="language" content="english" />
        {/* <meta
          property="fb:page_id"
          content="https://www.facebook.com/username"
        /> */}
        <meta name="generator" content="AI Nuture" />
        <meta name="copyright" content="© AI Nuture" />
        <meta name="description" content="AI Nuture" />
      </Helmet>
    </>
  );
}

export default Seo;
